export function formatCurrency(value, fractionDigits = 2) {
  // Remove all non-numeric characters except decimal point
  const numericValue = String(value).replace(/[^0-9.]/g, '');

  // If empty string or invalid number, return empty or 0
  if (!numericValue) return '$0';

  const number = parseFloat(numericValue);
  if (isNaN(number)) return '$0';

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(number);
}
